import { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import * as formStyles from '../TrailDetailItemForm/styles/styles.module.scss';
import * as styles from './styles/styles.module.scss';
import TrailAlertModal from '../../../components/TrailAlertModal';
import { wrapEventHandler } from '../../../utils/handlers';
import { alertTypeLabel, defaultAlertType } from '../../../utils/alerts_helpers';
import { adjustToSameNominalTimeForUser, monthDayYear } from '../../../utils/time_helpers';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import { FormattedMessage } from '@alltrails/shared/react-intl';

class TrailDetailAlertsEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: props.items,
      showAlertModal: false,
      alertModalIndex: null
    };
  }

  openAlertModal = index => {
    this.setState({ showAlertModal: true, alertModalIndex: index });
  };

  closeAlertModal = () => {
    this.setState({ showAlertModal: false });
  };

  handleAlertModalSubmit = formParams => {
    let items = [...this.state.items];
    if (this.state.alertModalIndex !== undefined) {
      items[this.state.alertModalIndex] = formParams;
    } else {
      items.push(formParams);
    }
    this.setState({ items, showAlertModal: false });
  };

  renderAlertModal = () => {
    return (
      this.state.showAlertModal && (
        <TrailAlertModal
          closeModal={wrapEventHandler(() => this.closeAlertModal())}
          handleSubmit={params => this.handleAlertModalSubmit(params)}
          showAreaFields={false}
          alert={this.state.alertModalIndex !== undefined ? this.state.items[this.state.alertModalIndex] : {}}
        />
      )
    );
  };

  addItem = () => {
    if (this.props.submitting) {
      return;
    }
    return this.openAlertModal();
  };

  editItem = index => {
    if (this.props.submitting) {
      return;
    }
    return this.openAlertModal(index);
  };

  deleteItem = index => {
    if (this.props.submitting) {
      return;
    }
    const { items } = this.state;
    items[index].deleted = true;
    this.setState({ items });
  };

  handleChange = (e, index) => {
    e.preventDefault();
    if (this.props.submitting) {
      return;
    }

    const { items } = this.state;
    items[index].content = e.currentTarget.value;
    this.setState({ items });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.props.submitting) {
      return;
    }

    this.props.handleSubmit(this.state.items);
  };

  renderRows = () => {
    return this.state.items.map((item, i) => {
      if (item.deleted) {
        return null;
      }
      let scheduledStart = '';
      let scheduledEnd = '';
      if (item.startDate) {
        const date = adjustToSameNominalTimeForUser(item.startDate);
        scheduledStart = `, starts ${monthDayYear(date, LanguageRegionCode.English, false)}`;
      }
      if (item.endDate) {
        const recurs = item.startDate && item.recursAnnually ? ', recurs' : '';
        const date = adjustToSameNominalTimeForUser(item.endDate);
        scheduledEnd = `, ends ${monthDayYear(date, LanguageRegionCode.English, false)}${recurs}`;
      }
      return (
        !item.deleted && (
          <tr key={i}>
            <td>
              <div>
                <b>{item.shortName}</b>
              </div>
              <div>{item.content}</div>
              <div>
                <i>
                  {alertTypeLabel(item.alertType || defaultAlertType.value)}
                  {scheduledStart}
                  {scheduledEnd}
                </i>
              </div>
            </td>
            <td>
              <div className={styles.buttonGroup}>
                <Button text="Edit" onClick={() => this.editItem(i)} testId="trail-details-alerts-editor-edit" size="sm" />
                <Button text="Delete" onClick={() => this.deleteItem(i)} testId="trail-details-alerts-editor-delete" size="sm" />
              </div>
            </td>
          </tr>
        )
      );
    });
  };

  renderFormButtons = () => {
    return (
      <div className={formStyles.buttonContainer}>
        <Button
          disabled={this.props.submitting}
          testId="trail-alerts-edit-submit"
          text={<FormattedMessage defaultMessage="Submit" />}
          type="submit"
          variant="primary"
          width="full"
        />
        <Button
          onClick={this.props.handleCancelPress}
          text={<FormattedMessage defaultMessage="Cancel" />}
          testId="trail-alerts-cancel"
          variant="flat"
        />
      </div>
    );
  };

  render() {
    const rows = this.renderRows();
    return (
      <form onSubmit={this.handleSubmit}>
        <table className={styles.itemTable}>
          <tbody>
            {rows}
            <tr>
              <td>
                <Button onClick={this.addItem} testId="admin-alerts-add" text="Add" />
              </td>
            </tr>
          </tbody>
        </table>
        {this.renderFormButtons()}
        {this.props.errorMessage && <p className={styles.errorMsg}>{this.props.errorMessage}</p>}
        {this.renderAlertModal()}
      </form>
    );
  }
}

TrailDetailAlertsEditor.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string
    })
  ),
  handleCancelPress: PropTypes.func,
  handleSubmit: PropTypes.func,
  errorMessage: PropTypes.string,
  submitting: PropTypes.bool
};

export default TrailDetailAlertsEditor;
